module.exports = __webpack_public_path__ + "static/img/__9165.a4ef1ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__9165.jpg
// module id = byOM
// module chunks = 0